'use strict'
import { request } from '../../plugins/http'

export default async (data) => {
    return await request.get('/produto',{params:data})
}